﻿import { GuiAuswertung } from "./GuiAuswertung";
import { IChartData } from "../Interface/IChartData"
import { Chart } from "../chart-setup";
export class GuiAuswertungAbfallbilanz extends GuiAuswertung {

    chart?: Chart;

    constructor() {
        super("GuiAuswertungAbfallbilanz");
    }

    draw() {
        
        const ctx = document.getElementById("chartAbfallbilanz") as HTMLCanvasElement;
        if (this.chart != undefined) {
            this.chart.destroy();
        }

        const jsonData = (<HTMLInputElement>document.getElementById("jsonAbfallbilanz")).value;
        if (jsonData != undefined && jsonData !== "null") {
            const pieData = JSON.parse(jsonData) as IChartData;
            const data = {
                labels: pieData.labels,
                datasets: [
                    {
                        label: "Abfallbilanz",
                        data: pieData.values,
                        backgroundColor: pieData.colors,
                        hoverOffset: 4
                    }
                ]
            };

            this.chart = new Chart(ctx, this.CreateDoughnutConfig(data, pieData.valuesArePercent));
        }
    }
}
